import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './PdfHeader.module.scss';
import dayjs from 'dayjs';
import { DATE_FORMAT_WITH_DAY_TIME_AND_NO_SLASH } from 'date-util';

const cx = classNames.bind(styles);

export type Props = {
  payeeName?: string;
  counterpartyCode?: string;
  payeeCode?: string;
};

export const PdfHeader: FC<Props> = memo(
  ({ payeeName, counterpartyCode, payeeCode }) => {
    const today = dayjs();
    const dateStr = today.format(DATE_FORMAT_WITH_DAY_TIME_AND_NO_SLASH);
    return (
      <div className={cx(styles.container)}>
        <span className={cx(styles.content)}>{counterpartyCode}</span>
        <span>_</span>
        <span className={cx(styles.content)}>{payeeCode}</span>
        <span>_</span>
        <span className={cx(styles.content)}>{payeeName}</span>
        <span>_{dateStr}.pdf</span>
      </div>
    );
  }
);
PdfHeader.displayName = 'PdfHeader';
